import i18next from "i18next";
import * as React from "react";
import { LanguageContainerStreamProps } from "../../containers/LanguageContainer/LanguageContainer";

export function GlobalLanguage(props: LanguageContainerStreamProps) {
    if (props.screenSaverAndIdleTimeoutState === "IDLE_TIMEOUT_END") {
        i18next.changeLanguage("de");
    }
    return <div />;
}
